var $9bee35dcd8ee2f43$exports = {};
$9bee35dcd8ee2f43$exports = {
    "decrease": (args)=>`\u{964D}\u{4F4E} ${args.fieldLabel}`,
    "increase": (args)=>`\u{63D0}\u{9AD8} ${args.fieldLabel}`,
    "numberField": `\u{6570}\u{5B57}\u{5B57}\u{6BB5}`
};


export {$9bee35dcd8ee2f43$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
